import { IUserSession } from '../../@types/employee';
import { createAction } from 'typesafe-actions';

export default class AuthActions {
    public static readonly authSetSession = createAction('AUTH_SET_SESSION', resolve => (session ?: IUserSession | null) => resolve(session));
    public static readonly authSetLoggedIn = createAction('AUTH_SET_LOGGED_IN', resolve => (loggedIn : boolean) => resolve(loggedIn));
    public static readonly authSetLoggingIn = createAction('AUTH_SET_LOGGING_IN', resolve => (loggingIn : boolean) => resolve(loggingIn));
}
